module.exports = __webpack_public_path__ + "img/a6-عمودی.5b76e7e9.jpg";